import { isNextPage } from '../utils/nextPages'

export default function ({ $config, store, route: to, from }) {
  // при первой клиентской отрисовке Nuxt вызывает middleware с from === to
  if (!process.client || !from || from.fullPath === to.fullPath) {
    return
  }
  if (
    $config.NEXT_PAGES_ROUTING_ENABLED &&
    isNextPage(to.path, store.state.settings.siteData?.NEXT_PAGES ?? [])
  ) {
    window.location.assign(($config.BASE_PATH || '') + to.fullPath)
    return new Promise(() => {})
  }
}
